import { IUserTeams, IUserTeamsProjects } from "app/types";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Avatar from "./Avatar";
import LetterCard from "app/components/LetterCard";
import { TicketsIcon } from "app/components/Icons";

interface BreadcrumbProps {
  teams: IUserTeams;
}

export default function Breadcrumb({ teams }: BreadcrumbProps) {
  const params = useParams();

  const { project, team } = params;
  const projects = teams?.projects[0];

  return (
    <div className="flex flex-row items-center gap-[6px] min-w-max px-[24px]">
      <div className="flex flex-row items-center gap-[6px]">
        <LetterCard
          className="!size-[16px] !min-w-[16px]"
          letterClassName="!text-secondary text-[8px] leading-[12px]"
          letter={teams?.icon?.initials}
          backgroundColor={
            teams?.icon?.bgColor ? teams?.icon?.bgColor : "#B3E8E9"
          }
          color={teams?.icon?.color ? teams?.icon?.color : "#79808A"}
        />
        <span className={clsx("text-sm")}>{teams?.teamName}</span>
        <span className="text-sm font-normal text-secondary">{"/"}</span>
        <LetterCard
          className="!size-[16px] !min-w-[16px]"
          letterClassName="!text-secondary text-[8px] leading-[12px]"
          letter={projects?.icon?.initials}
          backgroundColor={
            projects?.icon?.bgColor ? projects?.icon?.bgColor : "#B3E8E9"
          }
          color={projects?.icon?.color ? projects?.icon?.color : "#79808A"}
        />

        <span className={clsx("text-sm")}>{projects?.projectName}</span>
        <span className="text-sm font-normal text-secondary">{"/"}</span>
        <div className="flex flex-row items-center gap-[6px]">
          <TicketsIcon color="#253858" size={16} />
          <span className={clsx("text-sm !text-black font-medium")}>
            Tickets{" "}
          </span>
        </div>
      </div>
    </div>
  );
}
